import { useState, useEffect } from 'react';

export default function SearchTermSuggestions({searchTerm, useSuggestion}) {
  const limit = 5;
  const [suggestions, setSuggestions] = useState([]);
  const [previousSearchTerm, setPreviousSearchTerm] = useState('');
  const [searchRequestTimeout, setSearchRequestTimeout] = useState(null);
  function navigateToUrl(value) {
    window.location.href = `/zoeken?keys=${encodeURIComponent(value)}`;
  }

  useEffect(() => {
    let isMounted = true;

    if (previousSearchTerm !== searchTerm) {
      setPreviousSearchTerm(searchTerm);

      if (searchRequestTimeout) {
        clearTimeout(searchRequestTimeout);
      }

      if (searchTerm.length < 2) {
        setSuggestions([]);
      } else {
        setSearchRequestTimeout(setTimeout(() => {
          fetch('/search_api_autocomplete/zoeken?q=' + encodeURIComponent(searchTerm))
            .then(response => response.json())
            .then(data => {
              if (isMounted) {
                setSuggestions(data)
              }
            });
        }, 300))
      }
    }

    return () => {isMounted = false;};

  }, [searchTerm]);

  function handleSuggestionClick(e, value) {
    e.preventDefault(); // Prevent the default link behavior
    useSuggestion(value); // Update the search term in the parent
  }

  function renderSuggestion(suggestion) {
    const matchIndex = suggestion.value.toLowerCase().indexOf(searchTerm.toLowerCase());
    if (matchIndex === -1) {
      return <span>{suggestion.value}</span>;
    }

    const beforeMatch = suggestion.value.substring(0, matchIndex);
    const matchText = suggestion.value.substring(matchIndex, matchIndex + searchTerm.length);
    const afterMatch = suggestion.value.substring(matchIndex + searchTerm.length);

    return (
      <>
        {beforeMatch}<em>{matchText}</em>{afterMatch}
      </>
    );
  }

  if (!suggestions) {
    return '';
  }

  return (
    <>
      {suggestions.length > 0 &&
        <div className={"search-results__suggestions grid__column grid__column--main"} key={'search-term-suggestions'} data-fcs-region="search_term_results">
          <h2 className="search-results__heading">Zoeksuggesties</h2>
          <div className={"search-results__wrapper"}>
            <ul className={"search-results__list search__suggestion-list"}>
              {suggestions.slice(0, limit).map((suggestion, index) => (
                <li className={"search-result search__suggestion"} key={index}>
                  <svg className="icon icon-search" aria-hidden="true">
                    <use href="#icon-search"/>
                  </svg>
                  <button className={"search-result__suggestion search__suggestion__link button--stripped"} onClick={(e) => {
                    e.preventDefault();
                    handleSuggestionClick(e, suggestion.value);
                  }}>
                    {renderSuggestion(suggestion)}
                  </button>
                  {(index < suggestions.length - 1)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      }
    </>
  );
}
